import { inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE } from '@shared/local-storage.token';
import { NavigationExtras, Router, UrlTree } from '@angular/router';
import { ActiveFilters } from '@capturum/ui/dynamic-filters';
import { FilterMatchMode } from '@capturum/ui/api';

@Injectable()
export class ChartUtilsService {
  private storage = inject(LOCAL_STORAGE);
  private readonly router = inject(Router);

  public getOrCreateTooltip(): HTMLElement {
    let tooltipElRef = document.getElementById('chartjs-tooltip');

    if (!tooltipElRef) {
      tooltipElRef = document.createElement('div');
      tooltipElRef.id = 'chartjs-tooltip';
      tooltipElRef.style.position = 'absolute';
      tooltipElRef.style.pointerEvents = 'none';

      const table = document.createElement('table');

      table.style.margin = '0px';

      tooltipElRef.appendChild(table);
      document.body.appendChild(tooltipElRef);
    }

    return tooltipElRef;
  }

  public applyFiltersAndNavigate(
    filters: ActiveFilters[],
    options?: {
      storageKey: string;
      navigateTo: string | any[] | UrlTree;
      navExtras?: NavigationExtras;
    }
  ): void {
    this.storage.setItem(options?.storageKey, JSON.stringify(filters));
    this.storage.setItem('list_leads_filters', JSON.stringify(filters));
    if (options?.navigateTo) {
      const target = Array.isArray(options.navigateTo) ? options.navigateTo : [options.navigateTo];

      void this.router.navigate(target as any[], options.navExtras);
    }
  }

  public buildInFilter(field: string, value: string): ActiveFilters[] {
    const id = Array.isArray(value) ? value : [value];

    return [{ field, matchMode: FilterMatchMode.IN, value: id }];
  }

  public setTooltipCustomPosition(tooltipElRef: HTMLElement, tooltip: any, chart: any): void {
    const position = chart.canvas.getBoundingClientRect();

    tooltipElRef.style.left = position.left + window.pageXOffset + tooltip.caretX - 100 + 'px';
    tooltipElRef.style.top = position.top + window.pageYOffset + tooltip.caretY + 'px';
    tooltipElRef.style.opacity = '1';
    tooltipElRef.style.fontSize = '14px';
    tooltipElRef.style.fontFamily = 'LGEITextTTF';
    tooltipElRef.hidden = false;
  }
}
